
export interface ITimeSeriesIncludeBuilder {
    includeTags(): ITimeSeriesIncludeBuilder;
    includeDocument(): ITimeSeriesIncludeBuilder;
}
